import PropTypes from 'prop-types';
import { MenuItem, Stack, TextField } from '@mui/material';
import Iconify from 'src/components/iconify';
import { PHYSICAL_COUNTRY_OPTIONS } from 'src/utils/physical-api';

const CountryOption = ({ option }) => (
  <Stack direction="row" alignItems="center" spacing={1}>
    <Iconify icon={option.flag} width={20} />
    <span>{option.label}</span>
  </Stack>
);

CountryOption.propTypes = {
  option: PropTypes.object.isRequired,
};

const CountrySelect = ({ value, onChange, label, helperText, required, sx }) => (
  <TextField
    select
    variant="filled"
    label={label}
    required={required}
    value={value ?? ''}
    onChange={(e) => onChange(e.target.value)}
    helperText={helperText}
    sx={{ width: '96%', pr: '10px', ...sx }}
    SelectProps={{
      renderValue: (selected) => {
        const option = PHYSICAL_COUNTRY_OPTIONS.find((o) => o.value === selected);
        return option ? <CountryOption option={option} /> : '';
      },
    }}
  >
    {PHYSICAL_COUNTRY_OPTIONS.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        <CountryOption option={option} />
      </MenuItem>
    ))}
  </TextField>
);

CountrySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  sx: PropTypes.object,
};

CountrySelect.defaultProps = {
  value: '',
  label: 'Country',
  helperText: '',
  required: false,
  sx: {},
};

export default CountrySelect;
